import React, { useEffect, useState, useRef } from "react";
import "../Styles/Bar.css";
import { Link } from "react-router-dom";

const Bar = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const handleMenuClick = () => {
    setMenuOpen(!isMenuOpen);
  };

  const handleOutsideClick = (event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      !event.target.closest(".hamburger-button")
    ) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="golo">
      <div
        className={`hamburger-button ${isMenuOpen ? "open" : ""}`}
        onClick={handleMenuClick}
      >
        <div className="bar" />
        <div className="bar" />
        <div className="bar" />
      </div>

      <nav ref={menuRef} className={`navigation ${isMenuOpen ? "active" : ""}`}>
        <ul>
          <li className="menu-item">
            <Link
              to="/blog"
              onClick={() => setMenuOpen(false)}
              className="nevHeaders menu-link"
            >
              Blog Post
            </Link>
          </li>

          {/* <hr className="menu-line" /> */}

          <li className="menu-item">
            <Link
              to="/tutorialseries"
              onClick={() => setMenuOpen(false)}
              className="nevHeaders menu-link"
            >
              TutorialSeries
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Bar;
